import { Chip, FormControl, InputLabel, MenuItem, Select, SxProps, Theme } from "@mui/material";
import { CSSProperties, useState } from "react";
import { KonserModel } from "../../models/businessModels/KonserModel";
import { CsmText } from "../../library/components/mui/CsmText";
import Columns from "../../library/components/layout/Columns";
import StringHelper from "../../library/helpers/StringHelper";

interface IVatanKonserSelectFieldBaseProps {
    id?: string,
    value: string | null,
    label: string,
    tumKonserler: KonserModel[],
    error?: boolean,
    fontSize?: number,
    sx?: SxProps<Theme>,
    style?: CSSProperties,
    disabled?: boolean,
}

export interface IVatanKonserSelectFieldProps extends IVatanKonserSelectFieldBaseProps {
    onChange: (e: string) => void,
}

export interface IVatanKonserWithNullSelectFieldProps extends IVatanKonserSelectFieldBaseProps {
    onChange: (e: string | null) => void,
}

export default function VatanKonserSelectField(props: IVatanKonserSelectFieldProps) {
    const { onChange, ...rest } = props;

    return <VatanKonserSelectFieldBase
        {...rest}
        onChange={e => onChange(e!)}
        enableUnSelect={false}
    />
}

export function VatanKonserWithNullSelectField(props: IVatanKonserWithNullSelectFieldProps) {
    return <VatanKonserSelectFieldBase
        {...props}
        enableUnSelect={true}
    />
}

function VatanKonserSelectFieldBase(props: IVatanKonserWithNullSelectFieldProps & { enableUnSelect: boolean }) {
    const { id, value, label, tumKonserler: tumKonserleri, onChange, error, fontSize, sx, disabled, style, enableUnSelect } = props;
    const fontSizeToUse = fontSize ?? 14;
    const [open, setOpen] = useState(false);

    const list = (tumKonserleri ?? []).orderByTurkish(e => e.isim);

    const chipClicked = (newId: string) => {
        if (value !== newId)
            onChange(newId);
        else {
            if (enableUnSelect)
                onChange(null);
        }

        handleClose();
    }

    const getChipMenuItem = (konser: KonserModel, isSelected: boolean): React.ReactNode => {
        return <Chip
            key={konser.id}
            label={konser.isim}
            onClick={() => { chipClicked(konser.id) }}
            color={isSelected ? "primary" : undefined}
            style={{ margin: "5px", cursor: "pointer", display: "flex" }}
        />;
        // return <MenuItem style={{ display: "flex" }} key={konser.id} value={konser.id}>
        //     <Chip style={{ display: "flex"}} key={konser.id} label={konser.isim} />
        // </MenuItem>
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <FormControl fullWidth style={{ marginTop: 0, ...style }}>
            <InputLabel error={error} id={"label" + label}>{label}</InputLabel>
            <Select
                defaultValue=""
                open={open}
                onClose={handleClose}
                onOpen={handleOpen}
                native={false}
                disabled={disabled}
                sx={sx}
                inputProps={{ style: { paddingTop: "5px !important", paddingBottom: "5px !important", fontSize: fontSizeToUse } }}
                error={error}
                labelId={id}
                MenuProps={{ MenuListProps: { style: { display: "flex", flexWrap: "wrap" } } }}
                id={id}
                value={StringHelper.nullToEmpty(value)}
                label={label}
                renderValue={() => <CsmText>{list.singleOrDefault(e => e.id === value)?.isim}</CsmText>}
                onChange={(e) => { onChange(e.target.value); }}>
                {list.map(e => <MenuItem key={e.id} value={e.id} style={{ display: "none" }} />)}
                <Columns flex wrap>
                    {list.map(e => getChipMenuItem(e, e.id === value))}
                </Columns>
            </Select>
        </FormControl>
    );
}
